<page-toolbar [pageActions]="pageActions" [title]="title"></page-toolbar>

<page-content [noPadding]="true">
  <data-table (detail)="onDetail($event)" (remove)="onRemove($event)" (edit)="onEdit($event)" [columns]="columns" [title]="title"
                  [dataProvider]="organisationCustomerService" [searchColumns]="searchColumns" [searchAll]="true"></data-table>
</page-content>
